import { render, staticRenderFns } from "./ConvertAddressItem.vue?vue&type=template&id=1ddb7354&scoped=true&"
import script from "./ConvertAddressItem.vue?vue&type=script&lang=js&"
export * from "./ConvertAddressItem.vue?vue&type=script&lang=js&"
import style0 from "./ConvertAddressItem.vue?vue&type=style&index=0&id=1ddb7354&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddb7354",
  null
  
)

export default component.exports